// extracted by mini-css-extract-plugin
export default {"form":"style_form__qB+Lr","errorText":"style_errorText__NoG-x","submit":"style_submit__h6guZ","inputLabel":"style_inputLabel__banad"};